import { render } from "./CoordinatorsListingTable.vue?vue&type=template&id=0aaa195f"
import script from "./CoordinatorsListingTable.vue?vue&type=script&lang=js"
export * from "./CoordinatorsListingTable.vue?vue&type=script&lang=js"

import "./CoordinatorsListingTable.vue?vue&type=style&index=0&id=0aaa195f&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__